import { CONTENT_TYPES_LIST } from '../../../../../constants/value';
import type { TypeElementResponseAPI } from '../../../../../types/type';
import type { ContentType } from '../../../../../types/value';

const validContentTypes: ContentType[] = [
    'ContentString',
    'ContentNumber',
    'ContentBoolean',
    'ContentDateTime',
    'ContentDate',
    'ContentContent',
];

export const suggestSupportedContentTypes: ContentType[] = [
    'ContentString',
    'ContentNumber',
    'ContentBoolean',
    'ContentDateTime',
    'ContentDate',
    'ContentContent',
    'ContentList',
];

export const getValidProperties = (type: TypeElementResponseAPI | null) =>
    type?.properties?.filter((prop) =>
        validContentTypes.includes(prop?.contentType as ContentType),
    ) ?? [];

export const getNumberProperties = (type: TypeElementResponseAPI | null) =>
    type?.properties?.filter((prop) => prop?.contentType === 'ContentNumber') ?? [];

export const invalidContentTypesString = CONTENT_TYPES_LIST.filter(
    (item) => validContentTypes.includes(item.key as ContentType) === false,
)
    .map(({ label }) => label)
    .join('/');

export const suggestSupportedContentTypesString = CONTENT_TYPES_LIST.filter((item) =>
    suggestSupportedContentTypes.includes(item.key as ContentType),
)
    .map(({ label }) => label)
    .join('/');

export const columnTypes = {
    none: 'none',
    single: 'single',
    multiple: 'multiple',
};
